import { render, staticRenderFns } from "./ProfileEditCurrent.vue?vue&type=template&id=5086910c&"
import script from "./ProfileEditCurrent.vue?vue&type=script&lang=js&"
export * from "./ProfileEditCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports